module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-fadein",
    class: {
      'is-out': !_vm.isVisible
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ab832c6"}!./src/scripts/components/app-fadein/template.html
// module id = 930
// module chunks = 0